export default "__VITE_ASSET__e82551fe__"